<template>
  <div>
    <keep-alive :include="list">
        <router-view class="view-router"></router-view>  
    </keep-alive>
    <router-view name="tabbar"></router-view>     
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: []
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.list = this.$mdUtils.getStore('keepAliveList') || []
      }
    }
  }
}
</script>

<style>
</style>


<style lang="scss" scoped>
#app {
  height: 100vh;
}
</style>
